// extracted by mini-css-extract-plugin
export var grid = "search-pagination-module--grid--f541d";
export var gridWithRowGap = "search-pagination-module--grid--with-row-gap--824fd";
export var maxWidthContainer = "search-pagination-module--max-width-container--1049b";
export var mt0 = "search-pagination-module--mt-0--59542";
export var mt1 = "search-pagination-module--mt-1--fe372";
export var mt2 = "search-pagination-module--mt-2--82508";
export var mt3 = "search-pagination-module--mt-3--ed5b1";
export var mt4 = "search-pagination-module--mt-4--7f89a";
export var mt5 = "search-pagination-module--mt-5--2846b";
export var mt6 = "search-pagination-module--mt-6--0b091";
export var removeVisuallyHidden = "search-pagination-module--remove-visually-hidden--7ae8c";
export var searchPagination = "search-pagination-module--search-pagination--e45e2";
export var searchPaginationDark = "search-pagination-module--search-pagination--dark--fffce";
export var searchPagination__icon = "search-pagination-module--search-pagination__icon--fee20";
export var searchPagination__item = "search-pagination-module--search-pagination__item--54c03";
export var searchPagination__itemCurrent = "search-pagination-module--search-pagination__item--current--40d78";
export var searchPagination__itemEllipsis = "search-pagination-module--search-pagination__item--ellipsis--26ffc";
export var searchPagination__itemHidden = "search-pagination-module--search-pagination__item--hidden--7297b";
export var searchPagination__item__iconBtn = "search-pagination-module--search-pagination__item__icon-btn--d8a14";
export var searchPagination__item__iconBtnNext = "search-pagination-module--search-pagination__item__icon--btn-next--95406";
export var searchPagination__items = "search-pagination-module--search-pagination__items--c77ec";
export var searchPagination__visuallyHidden = "search-pagination-module--search-pagination__visually-hidden--70ff0";
export var visuallyHidden = "search-pagination-module--visually-hidden--ab423";
export var widgetBase = "search-pagination-module--widget-base--ca9ad";